// extracted by mini-css-extract-plugin
export default {"langSwitcher":"pgfIxjNElp-1hD94DOAhEA==","language":"_3S2pd1eNaLj1e3nnkUzWyw=="};